import React from "react";
import Icon from "./Icon";
export default function Wave(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 11H16.5L13.75 19.25L8.25001 2.75L5.50001 11H1.83334"
  }));
}
Wave.displayname = "Wave";
//# sourceMappingURL=Wave.js.map